import debug from 'debug';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const log = (component: string, value: any, ...args: any) => {
  const logger = debug(`app:${component}`);
  logger(value, ...args);
};
